export default "__VITE_ASSET__D4smmy1x__"